<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table  :name="$options.name" ref="yt" getUrl="/custom/aps/plan/planFinishDifference"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <!-- <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList">
            </yi_data_select>
          </el-form-item> -->
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.planNo"></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList">
            </yi_data_select>
          </el-form-item> -->
          <el-form-item :label="$t('shifoupaichan')">
            <yi_dictionary_select :multiple="false" :max="10" :type="'SYSTEM_YES_NO'"
              :ids.sync="yt.conditions.mesScheduling"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('baogongshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime">
            </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ startTime: begin(), endTime: end() })">{{
      $t("chongzhi") }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button :loading="exportExcelLoading" size="mini" icon="yicon yicon-export" :title="$t('daochu')"
          @click="exportExcel()"></el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: "web_scheduling_plan_finish_difference_list",
  data() {
    return {
      columns: [
        {
          label: "jihuadanhao",
          prop: "planNo",
          width: 180
        }, {
          label: "chanpinbianma",
          prop: "materialVO.code",
          width: 130
        }, {
          label: "chanpinmingcheng",
          prop: "materialVO.name",
          width: 180
        }, {
          label: "paichanmujumingcheng",
          prop: "mouldVO.name",
          width: 130
        }, {
          label: "paichanmujubianhao",
          prop: "mouldVO.code",
          width: 130
        }, {
          label: "chanpinbianma",
          prop: "material.code",
          type: "dictionary",
          key: "SYSTEM_YES_NO",
          width: 130
        },{
          label: "messhifoupaichan",
          prop: "mesScheduling",
          type: "bool",
          width: 130
        },{
          label: "mespaichanjitai",
          prop: "mesEquipment.name",
          width: 130
        }, {
          label: "baogongjitai",
          prop: "machineNumber",
          width: 260
        },{
          label: "baogongshijian",
          prop: "reportTime",
          type: "time",
          width: 280
        }, {
          label: "caozuoren",
          prop: "operator",
          width: 130,
        },{
          label: "lingban",
          prop: "gaffer",
          width: 130,
        },{
          label: "banzu",
          prop: "team",
          width: 130,
        }],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, "startTime", this.begin());
      this.$set(this.yt.conditions, "endTime", this.end());
    }, 300);
  },
  methods: {
    beforeGet(params) {
      params["startTime"] = this.begin();
      params["endTime"] = this.end();
      return params;
    },
    begin() {
      console.log('重置begin')
      const date = new Date();
      const begin = new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + "01" + " 00:00:00").getTime();
      return begin;
    },
    end() {
      console.log('重置end')
      const date = new Date();
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
      return end;
    }
  },
};
</script>

<style scoped="scoped"></style>
